import { useTranslation } from '@hooks/useTranslation';
import { drop, DropMechanics, toy } from '@specs/specs';
import React, { FC, useState } from 'react';
import dynamic from 'next/dynamic';
import { Button, ButtonProps } from '@components/UIKit/Button/Button';
import { useCollectDrop } from '@hooks/useCollectDrop';
import { LinksEnum, replaceQuery } from '@specs/navigation';
import { useRouter } from 'next/router';
import { formatRubyAmount } from '@specs/helpers';
import { deleteCookie } from 'cookies-next';
const Modal = dynamic(import('@components/Modals/Modal').then(module => module.Modal), {
  ssr: false
});
const CollectBuyableDrop = dynamic(import('@components/Modals/Variants/CollectBuyableDrop/CollectBuyableDrop').then(module => module.CollectBuyableDrop), {
  ssr: false
});
interface CollectButtonProps extends Omit<ButtonProps, 'children'> {
  toyId: toy['id'];
  slug: toy['slug'];
  imageid: toy['imageid'];
  currentDrop: drop;
}
export const CollectButton: FC<CollectButtonProps> = ({
  toyId,
  slug,
  imageid,
  currentDrop,
  ...props
}) => {
  const router = useRouter();
  const {
    translate: tr
  } = useTranslation();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const {
    id: dropId,
    price,
    currency,
    alternativeCollect,
    mechanic
  } = currentDrop;
  const {
    collectHandler,
    isLoading
  } = useCollectDrop({
    toyId
  });
  const closeHandler = () => {
    setIsOpenModal(false);
  };
  const collectDrop = async () => {
    const data = await collectHandler({
      dropId
    });
    closeHandler();
    if (data?.status === 'success') {
      deleteCookie('redirectData');
      await replaceQuery(router, {
        secret: undefined,
        collectToyStatus: 'success'
      });
    }
  };
  const clickHandler = async () => {
    if (isBuyableDrop) {
      setIsOpenModal(true);
      return;
    }
    if (mechanic === DropMechanics.SECRET || mechanic === DropMechanics.SECRET_PERSONAL || alternativeCollect === 'FALSE') {
      await collectDrop();
    } else {
      await router.push({
        pathname: alternativeCollect === 'COMPETITION' ? LinksEnum.TOY_TASK_COMPETITION : alternativeCollect === 'ADS' ? LinksEnum.TOY_TASK_ADS : alternativeCollect === 'ARTIST_SUBSCRIPTION' ? LinksEnum.TOY_TASK_SUBSCRIPTION : '',
        query: {
          slug
        }
      });
    }
  };
  const isBuyableDrop = mechanic === 'BUY' && typeof price === 'number' && typeof currency === 'string';
  return <>
            <Button {...props} onClick={clickHandler} loading={isLoading} icons={isBuyableDrop ? {
      left: {
        name: currency === 'GOLD' ? 'gold' : 'ruby'
      }
    } : undefined} data-sentry-element="Button" data-sentry-source-file="CollectButton.tsx">
                {isBuyableDrop ? currency === 'RUBY' ? formatRubyAmount(price) : price : tr({
        id: 'btn.collect.now'
      })}
            </Button>
            {isBuyableDrop && <Modal isOpen={isOpenModal} onClose={closeHandler}>
                    <CollectBuyableDrop closeHandler={closeHandler} collectDrop={collectDrop} imageid={imageid} currency={currency} price={price} />
                </Modal>}
        </>;
};